// extracted by mini-css-extract-plugin
module.exports = {"techinput_level":"techinput_level--36oCLec9d","techinput_level__dot":"techinput_level__dot--3qraKio5e"};